/**
 * Global JavaScript for Paula Armolea Theme
 */

// Remove no-js class
document.documentElement.classList.remove('no-js');

// Cart functionality
class CartDrawer {
  constructor() {
    this.cart = document.querySelector('#cart-icon-bubble');
    this.init();
  }

  init() {
    // Update cart count on page load
    this.updateCartCount();
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.updateCartBubble(cart.item_count);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  updateCartBubble(count) {
    const bubble = document.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (bubble) {
        bubble.textContent = count;
      } else {
        const newBubble = document.createElement('span');
        newBubble.className = 'cart-count-bubble';
        newBubble.textContent = count;
        this.cart.appendChild(newBubble);
      }
    } else if (bubble) {
      bubble.remove();
    }
  }
}

// Initialize cart on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartDrawer();
  });
} else {
  new CartDrawer();
}

// Wishlist functionality (basic toggle)
document.addEventListener('click', (e) => {
  if (e.target.closest('.fav-button')) {
    const button = e.target.closest('.fav-button');
    const icon = button.querySelector('img');
    
    // Toggle between outline and filled heart
    if (icon.src.includes('heart.svg')) {
      // In a real implementation, you would save to localStorage or a wishlist app
      button.classList.toggle('is-active');
      console.log('Wishlist toggled');
    }
  }
});

// Search functionality
const searchForm = document.querySelector('.search-bar');
if (searchForm) {
  searchForm.addEventListener('submit', (e) => {
    const input = searchForm.querySelector('input[type="search"]');
    if (!input.value.trim()) {
      e.preventDefault();
      input.focus();
    }
  });
}

// Accessibility: Trap focus in modals
function trapFocus(element) {
  const focusableElements = element.querySelectorAll(
    'a[href], button:not([disabled]), textarea, input, select'
  );
  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  element.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  });
}

// Export for use in other scripts
window.theme = {
  trapFocus,
  CartDrawer
};

